// HOOKS
import { useRef, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_CLASSNAMES = {
  container: "relative flex",
  currentLabelContainer:
    " rounded group bg-primary text-white shadow shadow-secondary flex flex-col relative",
  labelContainer:
    "hover:underline decoration-primary rounded group bg-secondary text-white hover:bg-secondary shadow shadow-secondary flex flex-col relative",
  containerLabel: "font-ubuntuMedium cursor-pointer p-2",
  dropdown:
    "border-animate rounded overflow-y-auto absolute backdrop-blur-sm bg-greenGlass flex flex-col gap-1 p-2 top-11 z-50",
  valueContainer:
    "absolute right-[1px] top-[1px] flex items-center justify-center text-center text-xs leading-none min-w-[20px] min-h-[20px] active:drop-shadow group-hover:bg-primary group-hover:text-white rounded-full text-white bg-secondary",
};

const NavDropdown = ({
  label = "",
  value = null,
  classNames = DEFAULT_CLASSNAMES,
  children,
}) => {
  const [dropdown, setDropdown] = useState(false);
  const ref = useRef();
  const location = useLocation();
  const isCurrent = location.pathname.includes(label.toLowerCase());
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });
  const handleClick = () => {
    setDropdown(!dropdown);
  };
  return (
    <div
      ref={ref}
      className={classNames?.container || DEFAULT_CLASSNAMES.container}
    >
      <div
        onClick={handleClick}
        ref={ref}
        className={
          isCurrent
            ? classNames?.currentLabelContainer ||
              DEFAULT_CLASSNAMES.currentLabelContainer
            : classNames?.labelContainer || DEFAULT_CLASSNAMES.labelContainer
        }
      >
        <label
          className={
            classNames?.containerLabel || DEFAULT_CLASSNAMES.containerLabel
          }
        >
          {label}
        </label>
      </div>

      <div
        ref={ref}
        className={`${classNames?.dropdown || DEFAULT_CLASSNAMES.dropdown} ${
          !dropdown ? "hidden" : ""
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default NavDropdown;
